import {
  DEFAULT_INTL_LOCALE,
  type IntlLocal,
} from "./types/intl-locales.types";

export const toIntlLocale = (lng: string | undefined): IntlLocal => {
  if (lng) {
    if (lng.startsWith("fr")) return "fr-FR";
    if (lng.startsWith("en")) return "en-US";
  }

  return DEFAULT_INTL_LOCALE;
};
